import queryString from 'query-string'
import _ from 'lodash'

import { configurePagination } from './setCurrentPage'
import { configureSearchFilters } from './applyFilters'
import { configureSortOrder } from './applySortOrder'
import { fetchTours } from './fetchTours'

import { validateFilterConfig } from '../../utilities/filters/validators'
import { getIsDestinationPage } from '../../utilities/content/pages'
import { DEFAULT_CARDS_PER_PAGE } from '../../configuration/tripCards'
import { getDefaultSortOrder } from '../../utilities/content/sorting'

export const FETCH_CONFIG_BEGIN = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR'

export const fetchConfiguration = () => async dispatch => {
  dispatch({ type: FETCH_CONFIG_BEGIN })
  const queryParams = queryString.parse(window.location.search)
  let config = JSON.parse(localStorage.getItem('ylg_listings_search_config'))
  if (config) {
    const filters = validateFilterConfig(_.get(config, 'filters', {}))
    const isDestinationPage = getIsDestinationPage(filters)
    const configSortOrder = _.get(config, 'sortOrder')
    const defaultSortOrder = getDefaultSortOrder(isDestinationPage,configSortOrder)
    config = {
      brand: _.get(config, 'brand'),
      cardsPerPage: parseInt(_.get(config, 'cardsPerPage'), 10) || DEFAULT_CARDS_PER_PAGE,
      filters,
      isDestinationPage,
      sorting: defaultSortOrder,
    }
    dispatch({ type: FETCH_CONFIG_SUCCESS, payload: config })
    dispatch(configurePagination(queryParams))
    dispatch(configureSearchFilters(queryParams))
    dispatch(configureSortOrder(queryParams, defaultSortOrder))
    dispatch(fetchTours())
  }
}
